import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import VehicleEnquiryContainer from './vehicleEnquiryContainer';

const VehicleEnquiryRouter = (props) => {
  return (
    <BrowserRouter basename="/vehicle-enquiry/">
      <VehicleEnquiryContainer {...props} />
    </BrowserRouter>
  );
};

export default VehicleEnquiryRouter;
